// @flow

import { combineReducers } from 'redux';

import {
  GET_ROUTE,
  GET_ROUTE_SUCCESS,
  GET_ROUTE_FAILED,
} from '../constants';

import type {
  PdbId,
  RouteState,
  Loading,
  Loaded,
  RouteItem,
  NullAction,
  Actions,
  FetchRouteSuccess,
} from '../types';
import type { FlatError } from '../../../helpers/flattenError';

export const initialState: RouteState = {
  loading: false,
  loaded: false,
  error: null,
  pdbIds: [],
  item: {
    id: -1,
    disableComparer: false,
    template: '',
    language: 'nl',
    date: '',
    title: {
      rendered: '',
    },
    content: {
      rendered: '',
    },
    yoast: {
      yoast_wpseo_title: '',
    },
    type: 'page',
  },
};

const pdbIds = (
  state: Array<PdbId> = initialState.pdbIds,
  action: FetchRouteSuccess,
): Array<PdbId> => {
  switch (action.type) {
    case GET_ROUTE_SUCCESS: {
      // the all pdbIds found in this route
      return Object.keys(action.response.pdb || {});
    }
    default:
      return state;
  }
};

const item = (state: RouteItem = initialState.item, action: Actions): RouteItem => {
  switch (action.type) {
    case GET_ROUTE_SUCCESS: {
      const { pdb, ...rest } = action.response;
      return rest;
    }
    default:
      return state;
  }
};

const loading = (state: Loading = initialState.loading, action: Actions): Loading => {
  switch (action.type) {
    case GET_ROUTE:
      return true;
    case GET_ROUTE_SUCCESS:
    case GET_ROUTE_FAILED:
      return false;
    default:
      return state;
  }
};

const loaded = (state: Loaded = initialState.loaded, action: Actions): Loaded => {
  switch (action.type) {
    case GET_ROUTE:
      return false;
    case GET_ROUTE_SUCCESS:
      return true;
    default:
      return state;
  }
};

const error = (state: ?FlatError = initialState.error, action: Actions): ?FlatError => {
  switch (action.type) {
    case GET_ROUTE:
      return null;
    case GET_ROUTE_FAILED:
      return action.response;
    default:
      return state;
  }
};

const reducer = combineReducers<Object, Object>({
  loading,
  loaded,
  error,
  pdbIds,
  item,
});

export const routeReducer = (
  state: RouteState,
  action: Actions | NullAction,
): RouteState => reducer(state, action);

export default reducer;
